import { Button } from "src/@/components/ui/button"
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "src/@/components/ui/dialog"
import { Input } from "src/@/components/ui/input"
import { RowInput } from "src/components/forms/RowInput"
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "src/@/components/ui/select"

export default function ModalApis({
    open,
    onClose,
    onSubmit,
    action,
    nome,
    changeNome,
    tipo,
    changeTipo,
}) {
    return (
        <Dialog open={open} onOpenChange={(val) => !val && onClose()}>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>
                        {action === "Criar" ? "Nova Chave de API" : "Editar Chave de API"}
                    </DialogTitle>
                </DialogHeader>
                <div className="grid gap-4 py-4">
                    <RowInput
                        label="Nome da Chave"
                        input={<Input
                            onChange={changeNome}
                            value={nome}
                            placeholder="Ex: Integração XYZ"
                        />}
                    />

                    <RowInput
                        label="Tipo de Chave"
                        input={
                            <Select value={tipo} onValueChange={changeTipo}>
                                <SelectTrigger className="w-full">
                                    <SelectValue placeholder="Selecione o tipo" />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="global">Global</SelectItem>
                                    <SelectItem value="whatsapp">WhatsApp</SelectItem>
                                </SelectContent>
                            </Select>
                        }
                    />
                </div>
                <DialogFooter>
                    <Button onClick={onSubmit}>{action === "Criar" ? "Gerar Chave" : "Salvar"}</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
